<template>
  <div class="notification">
    <div class="notification-icon">
      <span class="icon-circle-check"></span>
    </div>
    <div class="notification-body">
      <h3 class="notification-title">
        {{ title }}
      </h3>
      <div class="notification-message">
        {{ message }}
      </div>
    </div>
    <mc-button
      clear
      icon="icon-close-cross-exit-quit-delete"
      class="notification-icon-close"
      @click="notificationStore.removeNotification(id)"
    >
    </mc-button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import McButton from "@/components/ui/McButton.vue";
import { useNotificationStore } from "@/store/notificationStore";

interface IMcNotificationProps {
  title: string;
  message: string;
  id: string;
}

const { id, title, message } = defineProps<IMcNotificationProps>();

const notificationStore = useNotificationStore();
const NOTIFICATION_TIMEOUT = 5000;

onMounted(() => {
    setTimeout(() => {
      notificationStore.removeNotification(id);
    }, NOTIFICATION_TIMEOUT);
});

</script>

<style scoped lang="scss">

.notification {
  --button-icon-font-size: 24px;

  max-width: 520px;
  width: 100%;
  background-color: #E6F6EB;
  box-shadow: 0px 8px 40px 0px #0000000D, 0px 12px 32px -16px #0000000E;
  border-radius: 8px;
  border: 1px solid #DBD8E0;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 8px;

  &-body {
    flex-grow: 1;
  }

  &-title {
    font-family: var(--font-family);
    font-size: var(--font-size-headers-medium);
    font-weight: var(--font-weight-body-medium);
    line-height: var(--line-height-l);
    text-align: left;
    color: #193B2D;
    margin: 0;
  }

  &-message {
    font-family: var(--font-family);
    font-size: var(--font-size-body-regular);
    font-weight: var(--font-weight-body-regular);
    line-height: var(--line-height-m);
    text-align: left;
    color: #218358;
    margin: 0;
  }

  &-icon{
    margin-left: 10px;

    span{
      color: var(--colour-icons-success-subtle);
      font-size: var(--Font-Size-Headers-Larg);
    }
    
    &-close {
      --button-text-color: var(--colour-text-neutral-subtle);
      --button-background-color: #20003618;
      --button-border: none;
      --button-border-hover: none;
      --button-border-active: none;
      --button-border-focus: none;
    }
  }
}

</style>